import _ from 'lodash';
import jsonStableStringify from 'json-stable-stringify';

const normalizeRangeItem = rangeItem => {
  return (angular.isUndefined(rangeItem) || rangeItem === '') ? null : rangeItem;
};

export const rangesAreEqual = (a, b) => {
  return (normalizeRangeItem(a.lte) === normalizeRangeItem(b.lte)) &&
    (normalizeRangeItem(a.gte) === normalizeRangeItem(b.gte));
};

export const valuesAreEqual = (type, a, b) => {
  if (type === 'geo') {
    return a && b && a.id !== undefined && a.type === b.type && a.id === b.id;
  } else if (type === 'range') {
    return rangesAreEqual(a, b);
  } else if (angular.isArray(a) || angular.isObject(a)) {
    return angular.equals(a, b);
  } else {
    return a === b;
  }
};

export const clone = (type, value) => {
  if (type === 'range') {
    return {
      gte: value.gte,
      lte: value.lte
    };
  } else {
    return value;
  }
};

export const getTagUniqueIdentifier = (tag) => {
  return jsonStableStringify(_.omit(tag, 'uniqueId', 'title'));
};

/**
 * @param {[]} array
 * @param {number} n
 * @return {Array[]}
 */
export const splitArrayInNArrays = (array, n) => {
  const result = [];
  while (array.length) {
    const chunkSize = Math.ceil(array.length / n--);
    result.push(array.slice(0, chunkSize));
    array = array.slice(chunkSize);
  }
  return result;
};

/**
 *
 * @param {object[]} array
 * @param {string} childrenParamName - параметр объекта, в котором лежит массив с детьми
 * @param {number} n - количество колонк, на которое надо разбить
 * @param {number} relTitleHeight - высота заголовка относительно детей
 */
export const splitArrayInNArraysByLength = (array, childrenParamName, n = 4, relTitleHeight = 2.5) => {
  // Случаи, когда можно просто разбить на колонки по количеству элементов:
  // 1. элементов столько же или меньше чем число колонок
  // 2. все элементы одинаковой длины
  const allItemsHaveEqualLength = _.every(array, item =>
    areItemsLengthEqual(item, array[0], childrenParamName, relTitleHeight));
  if (/* 1 */ array.length <= n || /* 2 */ allItemsHaveEqualLength)
    return splitArrayInNArrays(array, n);

  const columns = [];
  let itemsToSplit = _.clone(array);

  // Распределяем по колонкам (кроме последней - в неё попадёт всё оставшееся)
  for (let i = 0; i < (n - 1); i++) {
    if (!itemsToSplit.length) break;

    let currentLength = 0;
    const columnsLeft = n - i;
    const currentColumn = columns[i] = [];
    const totalLength = _.reduce(itemsToSplit,
      (res, item) => res + getItemLength(item, childrenParamName, relTitleHeight),
      0
    );
    // Желаемая длина колонки
    const targetLength = totalLength / columnsLeft;

    do {
      const lengthWithoutNext = currentLength;

      const nextItem = itemsToSplit.shift();
      currentColumn.push(nextItem);
      currentLength += getItemLength(nextItem, childrenParamName, relTitleHeight);

      // Заканчиваем, если колонка превысила желаемую длину
      if (currentColumn.length > 1 && currentLength > targetLength) {
        // Сравниваем длину колонки с новым элементом и без него
        // Выбираем тот вариант, который ближе к желаемому
        const deltaWith = currentLength - targetLength;
        const deltaWithout = targetLength - lengthWithoutNext;
        if (deltaWithout < deltaWith) {
          // Если без нового элемента было лучше, то возвращаем его в нераспределённые
          itemsToSplit.unshift(currentColumn.pop());
        }

        // Переходим к следующей колонке
        break;
      }

      // Переходим к следующей, если элементов осталось столько же, сколько колонок
      if (itemsToSplit.length < columnsLeft) break;
    } while (true);
  }

  // В последнюю колонку помещаем всё невошедшее в предыдущие колонки
  if (itemsToSplit.length) columns[n - 1] = itemsToSplit;

  return columns;
};

/**
 * @param {object} item
 * @param {string} childrenParamName
 * @param {number} relTitleHeight
 * @return {number}
 */
function getItemLength(item, childrenParamName, relTitleHeight) {
  return relTitleHeight + _.get(item, [childrenParamName, 'length'], 0);
}

function areItemsLengthEqual(itemA, itemB, childrenParamName, relTitleHeight) {
  return getItemLength(itemA, childrenParamName, relTitleHeight) ===
    getItemLength(itemB, childrenParamName, relTitleHeight);
}

export default {
  rangesAreEqual,
  valuesAreEqual,
  clone,
  getTagUniqueIdentifier,
  splitArrayInNArrays,
  splitArrayInNArraysByLength,
};



// WEBPACK FOOTER //
// ./src/serp/services/utils.js